import { apiRequest, getOrganizationUnique } from './utils.js';

class BaseApi {
  static getOrganizationUnique() {
    return getOrganizationUnique();
  }

  static async apiRequest(endpoint, options = {}) {
    return await apiRequest(endpoint, options);
  }

  static async get(endpoint) {
    return await this.apiRequest(endpoint);
  }

  static async post(endpoint, data) {
    return await this.apiRequest(endpoint, {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  static async put(endpoint, data) {
    return await this.apiRequest(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

static async patch(endpoint, data = {}) {
    return await this.apiRequest(endpoint, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  static async delete(endpoint) {
    return await this.apiRequest(endpoint, {
      method: 'DELETE'
    });
  }

  // DELETE with a JSON request body. Plain `delete()` sends no body, but some
  // Symfony endpoints expect one on DELETE (e.g. remove-role, delete-invitations,
  // decline-statements). Mirrors `post`/`put`/`patch`; the `token` header +
  // `Content-Type: application/json` are applied by `apiRequest` as usual.
  static async deleteWithBody(endpoint, data = {}) {
    return await this.apiRequest(endpoint, {
      method: 'DELETE',
      body: JSON.stringify(data)
    });
  }

  static buildOrgEndpoint(path) {
    const organizationUnique = this.getOrganizationUnique();
    return `/org/${organizationUnique}${path}`;
  }
}

export default BaseApi;